$(document).ready(function () {
    console.log('why-us-kv-animations.js loaded');
    var WIDTH_LIMIT = 900; // Width limit to start animations
    var animationInterval = null;
    var isAnimating = false;

    function startAnimation() {
        if (isAnimating || $('.whyus-kv').length === 0) return;

        var leftElements = $('.whyus-kv .review-text-wrapper.left, .whyus-kv .review-image-wrapper.left');
        var rightElements = $('.whyus-kv .review-text-wrapper.right, .whyus-kv .review-image-wrapper.right');
        var currentIndex = 0;

        // Initially show left elements, hide right elements (but keep them in flow)
        leftElements.css({opacity: 1, visibility: 'visible', display: 'flex'});
        rightElements.css({opacity: 0, visibility: 'hidden', display: 'flex'});

        animationInterval = setInterval(function () {
            if (currentIndex === 0) {
                // Fade out leftElements by animating opacity, then hide visibility
                leftElements.animate({opacity: 0}, 500, function () {
                    leftElements.css('visibility', 'hidden');
                    // Fade in rightElements
                    rightElements.css('visibility', 'visible').animate({opacity: 1}, 500);
                });
                currentIndex = 1;
            } else {
                rightElements.animate({opacity: 0}, 500, function () {
                    rightElements.css('visibility', 'hidden');
                    leftElements.css('visibility', 'visible').animate({opacity: 1}, 500);
                });
                currentIndex = 0;
            }
        }, 5000);

        isAnimating = true;
    }

    function stopAnimation() {
        if (!isAnimating) return;

        clearInterval(animationInterval);
        $('.whyus-kv .review-text-wrapper, .whyus-kv .review-image-wrapper').stop(true, true).css({
            opacity: 1,
            visibility: 'visible',
            display: 'flex'
        });
        isAnimating = false;
    }



    function handleResize() {
        if ($(window).width() < WIDTH_LIMIT) {
            startAnimation();
        } else {
            stopAnimation();
        }
    }

    handleResize();

    var resizeTimer;
    $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(handleResize, 150);
    });
});
